import script from "./TopBar.vue?vue&type=script&setup=true&lang=js"
export * from "./TopBar.vue?vue&type=script&setup=true&lang=js"

import "./TopBar.vue?vue&type=style&index=0&id=ac98106e&scoped=true&lang=css"

import exportComponent from "/Users/Ios/Documents/project/FrontEnd/CodeReport/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac98106e"]])

export default __exports__